import {
  AuthErrorKind,
  ChangeEmailErrorKind,
  ChangePasswordErrorTypes,
  ReauthErrorKind,
} from '@griply/types';
import { getCalendarEventErrorCode } from '@griply/utils';
import { ImageUploadErrorKind } from 'shared/types/image-upload-error';

// Outcomes a form already renders; an `unknown` kind is reported where it is thrown.
const expectedMutationErrors = new Set<string>([
  ...Object.values(AuthErrorKind).filter(
    (kind) => kind !== AuthErrorKind.Unknown,
  ),
  ...Object.values(ChangeEmailErrorKind).filter(
    (kind) => kind !== ChangeEmailErrorKind.Unknown,
  ),
  ChangePasswordErrorTypes.WrongPassword,
  ChangePasswordErrorTypes.WeakPassword,
  ReauthErrorKind.WrongPassword,
  ReauthErrorKind.Cancelled,
  // Refused before the upload; the image picker says the file is too large
  ImageUploadErrorKind.TooLarge,
]);

// Opt-in per mutation, for codes every caller of that mutation already puts in front of the user.
const isExpectedForMutation = (error: unknown, meta: unknown): boolean => {
  const codes = (meta as { expectedErrorCodes?: unknown } | null)
    ?.expectedErrorCodes;
  const code = getCalendarEventErrorCode(error);

  return Array.isArray(codes) && !!code && codes.includes(code);
};

export const isExpectedMutationError = (
  error: unknown,
  // the mutation's `meta`; `{ expectedErrorCodes }` there names the codes its callers render
  meta?: unknown,
): boolean => {
  const kind = (error as { kind?: unknown } | null)?.kind;

  if (typeof kind === 'string' && expectedMutationErrors.has(kind)) {
    return true;
  }
  return isExpectedForMutation(error, meta);
};
